import { Grid, useMediaQuery } from '@mui/material';
import React, { useEffect, useMemo, useState } from 'react';
import { useLocation, useParams } from 'react-router-dom';
import {
    useGetIndividualAssetQuery,
    useGetIndividualReservationQuery,
    useGetRecurringReservationQuery,
} from '../../../app/Slices/SevenDayApiSlice';
import LoadingComponent from '../../../layout/styledcomponents/LoadingAnimations/LoadingComponent';
import ConfirmationModal from '../../shared/ConfirmationModal';
import EditReservationForm from '../../components/Reservations/EditReservation/EditReservationForm';
import ViewIndividualReservation from '../../components/Reservations/ViewReservations/ViewIndividualReservation';
import ViewRecurringReservation from '../../components/Reservations/ViewReservations/ViewRecurringReservation';

export default function ViewReservationsFormPage() {
    const location = useLocation();
    const { id: bookingId } = useParams();

    const isMobile = useMediaQuery('(max-width: 770px)');
    const isIpad = useMediaQuery('(max-width: 1200px)');

    const [open, setOpen] = useState(false);

    useEffect(() => {
        window.scrollTo(0, 0);
    }, []);

    const isEdit = window.location.href?.includes('editReservation');
    const isRecurring = window.location.href?.includes('ai-assistant');

    const isSubmitted =
        location?.state?.variant === 'submitted' ||
        location?.state?.page === 'submitted' ||
        window.location.href?.toLowerCase().includes('confirmation') ||
        window.location.href?.toLowerCase().includes('submitted');

    const { data: getIndividualReservation, isLoading: isLoadingReservation } =
        useGetIndividualReservationQuery(`/bookings/${bookingId}`, {
            refetchOnMountOrArgChange: true,
            skip: !bookingId || isRecurring,
        });

    const { data: getRecurringReservation, isLoading: isLoadingRecurring } =
        useGetRecurringReservationQuery(`/recurring-bookings/${bookingId}`, {
            skip: !bookingId || !isRecurring,
        });

    const assetModuleId = useMemo(() => {
        if (isRecurring) return getRecurringReservation?.[0]?.module?.id;
        return getIndividualReservation?.module?.id;
    }, [isRecurring, getRecurringReservation, getIndividualReservation]);

    const { data: getIndividualAsset, isLoading: isLoadingAsset } =
        useGetIndividualAssetQuery(`modules/${assetModuleId}`, {
            skip: !assetModuleId,
        });

    const isLoading =
        isLoadingReservation || isLoadingRecurring || isLoadingAsset;

    const handleChangeModal = () => setOpen(false);
    const handleCloseModal = () => setOpen(false);

    return (
        <>
            {isLoading ? (
                <Grid
                    sx={{
                        height: '100%',
                        width: '100%',
                        display: 'flex',
                        alignItems: 'center',
                        alignContent: 'center',
                        justifyContent: 'center',
                    }}
                >
                    <LoadingComponent />
                </Grid>
            ) : (
                <Grid
                    sx={{
                        width: '100%',
                        height: isIpad ? '150vh' : '100%',
                        display: 'flex',
                        flexDirection: 'column',
                        alignItems: 'stretch',
                        justifyContent: 'flex-start',
                        paddingBottom: '50px',
                    }}
                >
                    {isEdit ? (
                        <EditReservationForm
                            reservation={getIndividualReservation}
                        />
                    ) : isRecurring ? (
                        <ViewRecurringReservation
                            reservationDetails={getRecurringReservation}
                            individualAsset={getIndividualAsset}
                        />
                    ) : (
                        <ViewIndividualReservation
                            reservation={getIndividualReservation}
                            asset={getIndividualAsset}
                            variant={isSubmitted ? 'submitted' : 'view'}
                        />
                    )}
                </Grid>
            )}

            <ConfirmationModal
                open={open}
                onClose={handleCloseModal}
                onChange={handleChangeModal}
                message={'Cancel this reservation'}
                component={'reservation'}
            />
        </>
    );
}
